import type { CSSProperties } from "react";
import { DolapoTextProp } from "../props/interface";
import { TextAlign, TextStyle } from "../props/enums";

const textAlignMap: Record<number, CSSProperties["textAlign"]> = {
  [TextAlign.LEFT]: "left",
  [TextAlign.CENTER]: "center",
  [TextAlign.RIGHT]: "right",
};

const fontWeightMap: Record<
  number,
  NonNullable<CSSProperties["fontWeight"]>
> = {
  [TextStyle.NORMAL]: "normal",
  [TextStyle.SEMIBOLD]: "600",
  [TextStyle.BOLD]: "700",
};

function DolapoTextWithoutUnderline(props: DolapoTextProp) {
  const textStyle: CSSProperties = {
    fontSize: `${props.size}px`,
    color: props.color,
    textAlign: textAlignMap[props.textalign] ?? "left",
    fontWeight: fontWeightMap[props.fontWeight] ?? "400",
    marginBottom: props.hasMarginBottom ? `${props.marginBottom}px` : "0px",
    display: "inline-block",
    fontFamily: "LeagueSpartan, sans-serif",
    lineHeight: 1.5,
  };

  return <p style={textStyle}>{props.content}</p>;
}

export default DolapoTextWithoutUnderline;
